"use client"

import { useEffect, useState } from "react"
import { usePathname } from "next/navigation"
import { ArrowLeft, FlaskConical, X } from "lucide-react"
import { consumePreviewParams, previewHome, returnToHome } from "@/lib/bugfix-preview"

/**
 * Монтируется в корневом layout перед UserProvider: эффект срабатывает раньше проверок авторизации,
 * поэтому переданная сессия успевает сохраниться. На превью-сборке показывает плашку возврата.
 */
export function BugfixPreviewBridge() {
  const pathname = usePathname()
  const [home, setHome] = useState<{ home: string; label: string } | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    consumePreviewParams()
    setHome(previewHome())
  }, [])

  if (!home) return null
  const mobile = pathname?.startsWith("/mobile") ?? false
  const hostname = (() => {
    try {
      return new URL(home.home).hostname
    } catch {
      return home.home
    }
  })()

  return (
    <div
      className="pointer-events-none fixed inset-x-0 z-[10000] flex justify-center px-3"
      style={{ top: mobile ? "calc(env(safe-area-inset-top, 0px) + 6px)" : 8 }}
    >
      <div className="pointer-events-auto flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50/95 py-1 pl-3 pr-1 text-xs text-amber-900 shadow-lg backdrop-blur dark:border-amber-700 dark:bg-amber-950/90 dark:text-amber-100">
        <FlaskConical className="h-3.5 w-3.5 shrink-0" />
        <span className="max-w-[40vw] truncate font-medium">Сборка {home.label || "фикса"}</span>
        <button
          type="button"
          disabled={busy}
          onClick={() => {
            setBusy(true)
            void returnToHome(home.home, mobile)
          }}
          className="ml-1 flex items-center gap-1 rounded-full bg-amber-500 px-2.5 py-1 font-semibold text-white transition-opacity hover:opacity-90 active:opacity-80 disabled:opacity-60"
          title={`Вернуться на ${hostname}`}
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          {busy ? "Переключаем…" : "В dev"}
        </button>
        <button
          type="button"
          onClick={() => setHome(null)}
          className="flex h-6 w-6 items-center justify-center rounded-full text-amber-700 hover:bg-amber-100 dark:text-amber-300 dark:hover:bg-amber-900"
          aria-label="Скрыть плашку"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  )
}
